import Swiper from 'swiper';
import { withFocusManagement } from 'helpers/swiper/swiperFocusManagement';

export const VideoThumbSlider = () => {
    const _config = {
        videoThumbSwiperClass: '.video-thumbs-swiper'
    };

    // Setup thumbs slider
    const swiperThumbsEl = document.querySelector(_config.videoThumbSwiperClass);
    if (swiperThumbsEl) {
        const swiperConfig = withFocusManagement({
            spaceBetween: 16,
            slidesPerView: 'auto'
        });

        // new Swiper
        new Swiper(_config.videoThumbSwiperClass, swiperConfig);
    }
};
